export default __webpack_public_path__ + "static/searchplay-ceb04a9e279a0255b559290537c1faed.png";